import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
// Components across the app
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { RopoComponent } from './components/ropo/ropo.component';
import { MatDialogModule } from '@angular/material/dialog';
import { QbInputModule } from '@fwmovilidad/qb-lib-ng-components';
import { SafeHtmlPipe } from './pipes/safeHtml.pipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatDialogModule,
    QbInputModule,
  ],
  declarations: [
    BreadcrumbComponent,
    RopoComponent,
    SafeHtmlPipe,
  ],
  exports: [
    BreadcrumbComponent,
    RopoComponent,
    SafeHtmlPipe,
  ],
})
export class SharedModule { }
